import { forwardRef, memo } from 'react';
export let Variant;

(function (Variant) {
  Variant["PRIMARY"] = "primary";
  Variant["SECONDARY"] = "secondary";
  Variant["SUCCESS"] = "success";
  Variant["DANGER"] = "danger";
  Variant["WARNING"] = "warning";
  Variant["INFO"] = "info";
})(Variant || (Variant = {}));

export let Size;

(function (Size) {
  Size["EXTRA_SMALL"] = "xs";
  Size["SMALL"] = "sm";
  Size["LARGE"] = "lg";
  Size["EXTRA_LARGE"] = "xl";
  Size["EXTRA_XLARGE"] = "xxl";
})(Size || (Size = {}));

export const AliasMemoWithChain = memo;
export const AliasForwardRefWithChain = forwardRef;